module.exports = "<div *ngIf=\"isInProgress\" class=\"bar\">\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/partials/progress-bar/progress-bar.component.html
// module id = ./src/app/core/components/partials/progress-bar/progress-bar.component.html
// module chunks = main